<sim-basic-material-dialog
	[headerIcon]="{fontSet: 'fad', fontIcon: 'fa-tags'}"
	(closeClicked)="ok()"
	[finished]="finished"
	[headerText]="T.TAG_SELECTION_DIALOG_HEADER | translate"
	[matDialogData]="data"
	[rect]="rect"
	[smallHeader]="true"
>
	<ng-container dialogContent>
		<sim-tags-chip-input
			[taggableObject]="data.taggableObject"
			[tagType]="data.tagType"
			(onChange)="updateTaggableObjectTags($event)"
		/>
	</ng-container>

	<ng-container actions>
		<sim-button
			(onClick)="ok()"
			[color]="'accent'"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="T.CONFIGURATION_EDITOR_CAMERA_OK"
		/>
	</ng-container>
</sim-basic-material-dialog>
